<div class="ds-header-stepper">
  <div class="header ds-heading-1">
    {{ title }}
    <p class="ds-color-core-neutral-7">
      <span>{{ currentStep }}</span>/<span>{{ totalSteps }}</span>
    </p>
  </div>
  <app-ds-progress-bar [percentage]="getPercentage()" [type]="getPercentage() >= 100 ? finalType : type"></app-ds-progress-bar>
</div>
